<template>
  <div class="staff_list_area">
    <ul>
      <li
        v-if="members.length <= 0"
        class="list_empty"
      >
        <slot name="empty">メンバーがいません</slot>
      </li>
      <organization-member
        v-for="organizationMember in members"
        :key="organizationMember.user_id"
        :organization="organization"
        :member="organizationMember"
        @update="updateOrganizationMembers"
        @add-contract="addContract"
      />
    </ul>
  </div>
</template>
<script>
  import OrganizationMember from "../organizations/organization_member.vue"

  export default {
    components: {
      OrganizationMember,
    },
    props: {
      organization: {
        type: Object,
        requires: true,
        default: null
      },
      organizationMembers: {
        type: Array,
        requires: true,
        default: null
      },
    },
    data () {
      return {
       members: [],
      }
    },
    watch: {
      organizationMembers (users) {
        this.members = users
      }
    },
    created () {
      this.members = this.organizationMembers
    },
    methods: {
      updateOrganizationMembers(organizationMember) {
        this.members.splice(this.members.map( m => m.id ).indexOf(organizationMember.id), 1, organizationMember);
        this.$emit('update', this.members)
      },
      addContract() {
        this.$emit('add-contract')
      }
    }
  }
</script>
<style scoped>
.loader {
  font-size: 50px;
}
</style>
